import { MV_BASIC_ENCRYPTION_KEY, VERIFICATION_SERVER_URL } from '../shared/consts';
import { encodeEncryptStr } from '../shared/basicEncryption';
import { DEBUG_LOGS_ROUTE } from '../shared/consts';

export async function sendLogsToVerificationServer(logLines: string[]) {
    const reportLogsUrl = VERIFICATION_SERVER_URL + DEBUG_LOGS_ROUTE;
    const encryptedLogsStr = encodeEncryptStr(logLines.join('\n'), MV_BASIC_ENCRYPTION_KEY);
    fetch(reportLogsUrl, {
        'method': 'POST',
        body: encryptedLogsStr,
        headers: {
            'Content-Type': 'text/plain',
        },
    }).catch((error) => {});
}